export const slug = "staff-users";
export const title = "Staff Users";
export const section = "Administration";
export const content = `
# Staff Users

The Staff Users page lets admins invite and manage the people who use this system.

## Roles

Every staff account is assigned one of three roles:

| Role | What they can do |
|------|-----------------|
| **Admin** | Full access, including Settings, Staff Users, and Audit Log |
| **Writer** | Can create and edit client records, log visits, and manage programs |
| **Viewer** | Read-only access — can view but not modify anything |

## Page-Level Permissions

In addition to roles, admins can grant or restrict access to specific pages for individual staff members. For example, a Writer can be blocked from accessing the Reports page if needed.

Permissions are managed via the **Permissions** column in the staff list. Click a staff member's row to open their account and adjust their page-level access.

## Inviting Staff

1. Click **Invite Staff Member**.
2. Enter their name and email address.
3. Choose their role.
4. Click **Send Invite**.

The invitee receives an email with a link to set up their account. The link expires after 48 hours.

## Editing an Account

Click any staff member's row to open their profile. You can update their name, email, role, or page-level permissions. Saving changes takes effect immediately.

## Self-Service Invite Requests

If your food bank allows it, prospective staff can request access via a public invite-request form. Submitted requests appear in the Staff Users page under the **Invite Requests** tab. An admin can approve or deny each request.

## Deactivating an Account

To remove a staff member's access without deleting their history, click **Deactivate** on their account page. Deactivated accounts cannot log in but their audit trail entries are preserved.
`;
